import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TokenAdminGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const tokenAdmin = localStorage.getItem('tokenAdmin');

    if (tokenAdmin && tokenAdmin.trim() !== '') {
       return true;
    } else {
       this.router.navigate(['/unauthorized']);
      return false;
    }
  }
}
